export function fakeLinks() {
    document.querySelectorAll('a[data-href]').forEach($item => {
        $item.addEventListener('click', function(e) {
            $item.setAttribute('href', $item.dataset.href);

            return true;
        });
    });
}